<script>
  import router from '../lib/router';
  import { onMount } from 'svelte';
  import APIClient from '../state-charts/api-client';

  import Profile from './public-profile.js';
  import AuthenticatedLayout from '../app-shell/authorized-app/Layout.svelte';
  import UserBanner from './components/UserBanner.svelte';
  import ProfileHeaderInfo from './components/ProfileHeaderInfo.svelte';
  import Feedbacks from './components/Feedbacks.svelte';
  import Rating from './components/Rating.svelte';

  import { TS } from '../config/translation-keys.js';
  import { t9n } from '../lib/translate.js';

  // component options  ------------------------------------------------------ //

  export let route_name;
  export let query;

  let btn_back;
  let is_applicant = false;

  // utility functions ------------------------------------------------------- //

  const add_user_banner = (target, profile) => {
    new UserBanner({ target: target, props: { profile: profile } });
  };

  const add_profile_header = (target, profile, is_applicant, order_uuid) => {
    new ProfileHeaderInfo({
      target: target,
      props: {
        profile: profile,
        is_applicant: is_applicant,
        order_uuid: order_uuid,
      },
    });
  };

  const add_feedback = (target, profile, percentages, feedbacks_count) => {
    new Feedbacks({ target: target, props: { profile: profile, percentages: percentages, feedbacks_count: feedbacks_count } });
  };

  const add_rating = (target, percentages) => {
    new Rating({target: target, props: { percentages: percentages }})
  }

  // initialization ----------------------------------------------------------- //

  const init_public_profile = async () => {
    document.querySelector('.mdc-top-app-bar--fixed-adjust').scrollIntoView({behavior: "smooth"})

    const target = document.querySelector('#feedback_section');
    let profile;
    let order_uuid;

    if (!!query && !!query.order_uuid && !!query.user_id) {
      order_uuid = query.order_uuid;
      is_applicant = !!query.applicant && query.applicant === 'true';
      profile = await Profile.load_profile_for_order(
        query.order_uuid,
        query.user_id,
        query.age_range
      );


    } else {
      profile = await Profile.load_profile();
      if(profile._user.stats.worker_overall_rating === null) profile._user.stats.worker_overall_rating = 0;
    }

    let api_data = {
      role: 'worker',
      statuses: [ 'order_status_initialized', 'order_status_in_progress', 'order_status_delivered', 'order_status_not_approved', 'order_status_completed', 'order_status_cancelled_by_worker', 'order_status_cancelled_by_orderer', 'order_status_cancelled_by_admin'],
    };

    let cv_gigs = await APIClient.get_orders(api_data);
    let orders = cv_gigs.orders;

    add_user_banner(target, profile);
    add_profile_header(target, profile, is_applicant, order_uuid);

    let percentages;
    let feedbacks_count;

    if(profile._role === 'orderer'){

      if(!!profile?._user.stats?.orderer_feedbacks?.percentages){
        percentages = profile._user.stats.orderer_feedbacks.percentages;
        feedbacks_count = profile._user.stats.orderer_feedbacks.count;
      } else if(!!profile?._user.stats?.feedbacks?.orderer?.percentages){
        percentages = profile._user.stats.feedbacks.orderer.percentages;
        feedbacks_count = profile._user.stats.feedbacks.orderer.count;
      }


    } else{
      if(!!profile?._user.stats?.worker_feedbacks?.percentages){
        percentages = profile._user.stats.worker_feedbacks.percentages;
        feedbacks_count = profile._user.stats.worker_feedbacks.count;
      } else if(!!profile?._user.stats?.feedbacks?.worker?.percentages){
        percentages = profile._user.stats.feedbacks.worker.percentages;
        feedbacks_count = profile._user.stats.feedbacks.worker.count;
      }

      // percentages = profile._user.stats.worker_feedbacks.percentages || profile._user.stats.feedbacks.worker.percentages;
    }

    // add_rating(target, percentages);

    add_feedback(target, profile, percentages, feedbacks_count);
  };

  $: {
    btn_back = t9n(TS.TXT_BACK);
  }

  onMount(async () => await init_public_profile());
</script>

  <main class="wrapper">
    <div>
      <section class="perspective" id="feedback_section" />
      <div id="bottom_buttons_section">

        {#if !!query && !!query.order_uuid}
          <button
            on:click={() => router.navigate('/order-details?id=' + query.order_uuid)}
            class="mdc-button mdc-button--unelevated order-back-button">
            <span class="mdc-button__ripple" />
            {btn_back}
          </button>
        {/if}
      </div>
    </div>

    <div class="select-dialog" />

  </main>

<style type="text/scss">
  main {
    display: flex;
    flex-direction: column;
    margin-top: 3rem !important;
    padding: 0.5rem 0.5rem;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.55);
    /*animation: fade-in-kf 2s ease forwards;*/
    /*animation-delay: 2.15s;*/
  }

  /* Needed for 3D sign effect */
  .perspective {
    -webkit-perspective: 1300px;
    -moz-perspective: 1300px;
    perspective: 1300px;
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .wrapper {
      width: 1000px;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .wrapper {
      width: 90%;
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .wrapper {
      /*width: 100%;*/
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }

    main {
      //width: 100%;
      margin: 0 auto;
      height: fit-content;
      margin-bottom: 100px;
      padding: 0;
      border-radius: 0;
    }
  }

  .order-back-button {
    margin-top: 8px;
    width: 100%;
  }
</style>
